var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alerts"},_vm._l((_vm.$store.state.alerts),function(alert,key){return _c('v-alert',{key:key,staticClass:"elevation-3",attrs:{"transition":"slide-x-reverse-transition","value":true,"type":alert.type,"dismissible":""}},[_vm._v(" "+_vm._s(alert.text)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }